import { render, staticRenderFns } from "./model-document-uploader-dialog.component.vue?vue&type=template&id=7587f157"
import script from "./model-document-uploader-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./model-document-uploader-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports